import React from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';

/**
 * LoadingPlaceholder
 * @param {string} message - Message to display below the spinner
 */
export default function LoadingPlaceholder({ message = 'Hang in tight — we’re fetching and preparing your bookmarks...' }) {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', mt: 6 }}>
      <CircularProgress size={64} color="primary" />
      <Typography variant="h6" color="textPrimary" sx={{ mt: 3, textAlign: 'center' }}>
        {message}
      </Typography>
    </Box>
  );
}
